module.exports = __webpack_public_path__ + "img/city-jungle-logo.aaf41530.png";